import { useEffect, useMemo, useState } from 'react';
import { getConfigValue } from '../data/system/systemConfig';

export const PAGE_SIZE_OPTIONS = [
  { value: '10', label: '10' },
  { value: '25', label: '25' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
];

export function usePagination(items, initialPageSize = getConfigValue('defaultPageSize')) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(initialPageSize);

  const totalCount = items.length;
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
  const currentPage = Math.min(page, totalPages);

  useEffect(() => {
    setPage(1);
  }, [items, pageSize]);

  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [page, totalPages]);

  const pageItems = useMemo(
    () => items.slice((currentPage - 1) * pageSize, currentPage * pageSize),
    [items, currentPage, pageSize],
  );

  const changePageSize = (size) => {
    setPageSize(Number(size) || 10);
  };

  return {
    page: currentPage,
    pageSize,
    totalCount,
    totalPages,
    pageItems,
    setPage,
    setPageSize: changePageSize,
  };
}
